
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "template"
})
export default class extends Vue {
}
